/* Bocock entrance motion and pulse gating. One observer set, three jobs.

   1. SECTION REVEAL, the heavy beat. A whole band lifts 44px and fades as it
      arrives. This is the one that gives the page its rhythm, because you feel a
      section land before you read anything inside it.

   2. ELEMENT REVEAL, the light beat. Cards, crests, cells and rows rise inside
      the band they belong to, staggered so a rail of four reads as a sequence
      instead of a slab. Their delay is offset past the band's own entrance so the
      two never fight. Crests also scale, which is the closest thing on a web page
      to a team being announced one name at a time.

   3. PULSE GATING. The yellow buttons only pulse while on screen. That is what
      makes a 2.4 second pulse survivable across a page with a dozen of them: you
      only ever see the one in front of you breathing, and the rest cost nothing,
      including no compositing work on a phone.

   PROGRESSIVE ENHANCEMENT, deliberately. The hidden state comes from the class
   this script puts on <html>, never from the base stylesheet. If the script fails,
   is blocked, or IntersectionObserver is missing, everything is simply visible.
   Scroll reveal that hides content in CSS ships a blank page to anyone whose JS
   did not run, and it is always the crawler and the person on hotel wifi who find
   it.

   Nothing in the hero moves. Above the fold has to be there on frame one. An
   entrance animation on a hero is a delay wearing a costume.

   12 September 2026. The trust strip is off the list too. It sits directly under
   the hero, is partly on screen at load on any desktop, and is the first proof a
   visitor sees. Making it fade in 820ms after the hero read as the page still
   loading, not as choreography. It now renders on frame one with the hero. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('bk-js');

  var SECTIONS = '.bkband,.bkfac,.bkkit,.bknl,.bk-press';
  var GROUPS = [
    ['.bkcrest', 34],
    ['.bkpc', 80],
    ['.bkdoor', 110],
    ['.bkfacstats > div', 70],
    ['.bklane', 120],
    ['.bkkitgrid .ki', 90],
    ['.bkqa', 45],
    ['.bkhead', 0],
    ['.bkkittxt', 0],
    ['.bkfactxt', 0]
  ];

  var reveal = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('bkin');
      reveal.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

  function tagSections() {
    document.querySelectorAll(SECTIONS).forEach(function (el) {
      if (el.closest('.bkhero') || el.dataset.bksec) return;
      el.dataset.bksec = '1';
      el.classList.add('bksecrev');
      reveal.observe(el);
    });
  }

  function tagGroup(sel, step) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.bkhero') || el.dataset.bkrev) return;
      el.dataset.bkrev = '1';
      el.classList.add('bkrev');
      var sibs = el.parentNode ? el.parentNode.children : [el];
      var i = Array.prototype.indexOf.call(sibs, el);
      if (i < 0) i = 0;
      if (i > 9) i = 9;
      /* 140ms head start so the band lands before its contents move. */
      el.style.setProperty('--d', (140 + i * step) + 'ms');
      reveal.observe(el);
    });
  }

  var pulser = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('bkinview', e.isIntersecting); });
  }, { threshold: 0.35 });

  function tagPulse() {
    document.querySelectorAll('.bkviewall,.bkbtn-g,.bkalt a').forEach(function (el) {
      if (el.dataset.bkpulse) return;
      el.dataset.bkpulse = '1';
      pulser.observe(el);
    });
  }

  /* Scoreboard count up, stats only. Not the price: a price has to be legible and
     trustworthy on the first frame, and animating it makes somebody wait to find
     out what a thing costs. Only pure integers run, optionally with one % or x
     suffix, so "Every" is left exactly as written. */
  var counter = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      counter.unobserve(el);
      var m = /^(\d+)([%x])?$/.exec(el.textContent.trim());
      if (!m) return;
      var end = parseInt(m[1], 10), suf = m[2] || '', t0 = null, dur = 900;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });

  function boot() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.documentElement.classList.remove('bk-js');
      return;
    }
    tagSections();
    GROUPS.forEach(function (g) { tagGroup(g[0], g[1]); });
    tagPulse();
    document.querySelectorAll('.bkfacstats b').forEach(function (el) {
      if (el.dataset.bkcount) return;
      el.dataset.bkcount = '1';
      counter.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
